import * as Sentry from '@sentry/browser';
import { AxiosError } from 'axios';
import {
  AuthenticationFailed,
  InternalServerError,
  NotFound,
  ServiceTemporaryUnavailable,
} from '../../repositories/exceptions/errors';

export const mapApiException = (err: AxiosError) => {
  if (err.response && err.response.status === 401) {
    throw new AuthenticationFailed(err);
  }

  if (err.response && err.response.status === 404) {
    throw new NotFound(err);
  }

  if (err.response && err.response.status === 500) {
    throw new InternalServerError(err);
  }

  if (err.response && [502, 503, 504].includes(err.response.status)) {
    throw new ServiceTemporaryUnavailable(err);
  }

  throw err;
};

export const reportApiException = (err: AxiosError) => {
  if (err.response && err.response.status === 500) {
    Sentry.withScope(scope => {
      Object.keys(err.config).forEach(key => {
        scope.setExtra(key, err.config[key]);
      });
      Sentry.captureException(err);
    });
  }

  throw err;
};
